import { useAuth0 } from "@auth0/auth0-react";

interface OAuthProvider {
  isAuthenticated: boolean;
  logout: (redirect: string | undefined) => Promise<void>;
  getToken: (name?: string, scopes?: string[]) => Promise<string>;
}

// Provider hook that creates auth object and handles state
export function useProvideOAuth() {
  const { isAuthenticated, logout, getAccessTokenSilently } = useAuth0();

  const handleLogout = async (redirect: string | undefined) => {
    return logout({
      logoutParams: { returnTo: redirect },
    });
  };

  const handleGetToken = async () => {
    const auth0scopes = "openid profile email";
    const result = await getAccessTokenSilently({
      authorizationParams: {
        scope: auth0scopes,
      },
    });
    return result || "";
  };

  return {
    isAuthenticated,
    logout: handleLogout,
    getToken: handleGetToken,
  } as OAuthProvider;
}
